import { api } from '../axios'
import type { ApiResponse } from '../../../types'

export interface Office {
  id: string
  name: string
  type: 'SDEO' | 'DEO'
}

export interface OfficesResponse {
  sdeo: Office[]
  deo: Office[]
  all: Office[]
}

export const officesApi = {
  getSDEOOffices: () =>
    api.get<ApiResponse<Office[]>>('/offices/sdeo'),

  getDEOOffices: () =>
    api.get<ApiResponse<Office[]>>('/offices/deo'),

  getAllOffices: () =>
    api.get<ApiResponse<OfficesResponse>>('/offices')
}

